<template>
  <div class="home">
<!--    <remote-script src="https://scripts.easyliao.com/js/easyliao.js"></remote-script>-->
<!--    <remote-script  src="https://scripts.easyliao.js"></remote-script>-->
<!--    <remote-script type="text/javascript" charset="UTF-8" src="https://scripts.easyliao.com/33395/64859.js"></remote-script>-->
<!--    <remote-script  src="https://scripts.easyliao.com//35078/60377.js"></remote-script>-->
    <top class="home_top"></top>
    <!-- <div>
      <el-carousel indicator-position="100" :interval="seconds" :height="bannerHeight + 'px'">
        <el-carousel-item v-for="(item, index) in imgLink" :key="index">
          <img style="width: 100%" :src="require('./img/' + item)" alt="">
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="contact">
      <div class="contact-item" onclick="openJesongChatByGroup(33395,41543);return false;">
        <div>
          <img style="width: 30px" src="./img/客服.png" alt="">
        </div>
        在线客服
      </div>
      <div class="contact-phone" @mouseover="hoverDetail" @mouseleave="deleteDetail">
        <div>
          <img style="width: 30px" src="./img/电话.png" alt="">
        </div>
        电话咨询
        <div v-if="phoneShow" id="phone1" class="detail-phone">0750-3921090</div>
      </div>
      <div class="contact-phone" @mouseover="hoverCodeDetail" @mouseleave="deleteCodeDetail">
        <div>
          <img style="width: 30px" src="./img/微信.png" alt="">
        </div>
        关注公众号
        <div v-if="codeShow" id="code" class="detail-code">
          <img style="width: 70px" src="./img/公众号.jpg" alt="">
        </div>
      </div>
    </div>
    <div class="navimg">
      <el-carousel  height="50vh" :interval="seconds">
        <el-carousel-item v-for="(item, index) in imgLink" :key="index">
          <!-- <h3>{{ item }}</h3> -->
            <img style="height:50vh;" :src="require('./img/' + item)" alt="" class="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <calm-module class="calm home_width"></calm-module>
    <quick-login class="quick home_width" ></quick-login>
    <tools class="tools home_width"></tools>
    <copyright></copyright>
<!--    <div class="chat-man">-->

<!--    </div>-->




<!--        <a class="bshareDiv" href="http://www.bshare.cn/share">分享按钮</a>-->
<!--    <remote-script type="text/javascript" charset="utf-8" src="http://static.bshare.cn/b/button.js#uuid=&amp;style=3&amp;fs=4&amp;textcolor=#fff&amp;bgcolor=#F60&amp;text=分享到"></remote-script>-->
  </div>
</template>


<script>
  import top from "../../components/content/top";
  import calmModule from "./components/common/calmModule";
  import quickLogin from "./components/content/quickLogin";
  import toolsContent from "./components/content/toolsContent";
  import copyright from "@/components/content/copyright";
  import 'common/importJS'

  // function browserRedirect() {
  //   var sUserAgent= navigator.userAgent.toLowerCase();
  //   var bIsIpad= sUserAgent.match(/ipad/i) == "ipad";
  //   var bIsIphoneOs= sUserAgent.match(/iphone os/i) == "iphone os";
  //   var bIsMidp= sUserAgent.match(/midp/i) == "midp";
  //   var bIsUc7= sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  //   var bIsUc= sUserAgent.match(/ucweb/i) == "ucweb";
  //   var bIsAndroid= sUserAgent.match(/android/i) == "android";
  //   var bIsCE= sUserAgent.match(/windows ce/i) == "windows ce";
  //   var bIsWM= sUserAgent.match(/windows mobile/i) == "windows mobile";
  //   if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
  //     return true;
  //   }
  //   return false;
  // }
  // if(browserRedirect()){
  //   // document.writeln('<script type="text/javascript" charset="UTF-8" src="//scripts.easyliao.com/33395/64368.js"></sc'+'ript>');
  // }else{
  //   document.writeln('<script type="text/javascript" charset="UTF-8" src="//scripts.easyliao.com/33395/64368.js"></sc'+'ript>');
  // }


  export default {
    name: "Home",
    components: {
      'top': top,
      'quickLogin': quickLogin,
      'calmModule': calmModule,
      'tools': toolsContent,
      'copyright': copyright,
    },
    data() {
      return {
        imgLink: [
          // '广告图1.jpg',
          // '广告图2.jpg'
          // '稿定设计-1.jpg',
          // '稿定设计-2.jpg',
          '稿定设计-4.jpg',
          '稿定设计-3.jpg',
          '稿定设计-5.jpg',
          '稿定设计-6.jpg',
        ],
        seconds:8000,
        // 图片父容器高度
        bannerHeight: 1000,
        // 浏览器宽度
        screenWidth: 0,
        phoneShow:false,
        codeShow:false,
      }
    },
    methods: {
      hoverDetail(){
        this.phoneShow = true
        var obj = document.getElementById("phone1");
        obj.style.marginRight= "70px";
      },
      deleteDetail(){
        this.phoneShow = false
        var obj = document.getElementById("phone1");
        obj.style.marginRight= "0px";
      },
      hoverCodeDetail(){
        this.codeShow = true
        var obj = document.getElementById("code");
        obj.style.marginRight= "70px";
      },
      deleteCodeDetail(){
        this.codeShow = false
        var obj = document.getElementById("code");
        obj.style.marginRight= "0";
      },
      setSize: function () {
        // 通过浏览器宽度(图片宽度)计算高度
        this.bannerHeight = 85 / 1920 * this.screenWidth;
        // console.log(this.bannerHeight)
      }
    },
    mounted() {
      // 首次加载时,需要调用一次
      this.screenWidth = window.innerWidth;
      this.setSize();
      // 窗口大小发生改变时,调用一次
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
        this.setSize();
      }
    }
  }

</script>

<style scoped>
  .home{
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: #f1f4f9;
  }

  /* .navimg{
    height: 450px;
    background-color: rgb(81,107,202);
  } */

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    /* opacity: 0.75; */
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    /* background-color: rgb(81,107,180) !important; */
    background-color: white !important;
    /* background-color: #99a9bf; */
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: white !important;
    /* background-color: red !important; */
    /* background-color: #d3dce6; */
  }

  .home_top{
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    z-index: 10;
  }

  .littleLogin{
    width: 10px;
    height: 10px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .chat-man{
    display: flex;
    justify-content: flex-end;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .contact{
    position: fixed;
    right: 0;
    top: 50%;
    z-index: 10;
    transform: translateY(10%);
  }

  .contact-item{
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(45,154,228);
  }

  .contact-item:hover{
    cursor: pointer;
  }

  .contact-phone{
    position: relative;
    padding: 10px;
    text-align: center;
    color: #ffffff;
    background-color: rgb(22,193,200);
  }

  .detail-phone{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 120px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    height: 40px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
    /*border: 1px solid #a8a8a8;*/
  }

  .detail-phone:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }

  .detail-code{
    text-align: center;
    color: rgb(22,193,200);
    background-color: #ffffff;
    position: absolute;
    top: 10px;
    width: 100px;
    height: 100px;
    padding: 12px 10px;
    /* font-width: bold; */
    font-size: 14px;
    right: 10px;
    /*margin-right: 70px;*/
    transition:margin-right 1s ease-in-out;
    -moz-transition:margin-right 1s ease-in-out; /* Firefox 4 */
    -webkit-transition:margin-right 1s ease-in-out; /* Safari and Chrome */
    -o-transition:margin-right 1s ease-in-out; /* Opera */
  }

  .detail-code:after{
    content: '';
    position: absolute;
    right: -6px;
    top: 12px;
    width: 10px;
    height: 10px;
    margin-bottom: -10px;
    background: inherit;
    transform: rotate(45deg);
    /*border-right: 1px solid #a8a8a8;*/
    /*border-top: 1px solid #a8a8a8;*/
  }
  .navimg img{
    position: absolute;
    left: 50%;
    overflow: hidden;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  /*.contact-item{*/
  /*  transition:margin-right 2s;*/
  /*  -webkit-transition:margin-right 2s ease-in-out;*/
  /*}*/

  /*.contact-item:hover{*/
  /*  margin-right: 100px;*/
  /*}*/
  @media screen and (max-width: 1200px) {
    .navimg img{
      height: 380px !important;
    }
    .navimg /deep/ .el-carousel__container{
      height: 380px !important;
    }
  }
  @media screen and (max-width: 1600px) {
    .home{
      min-width: 118rem;
      padding-bottom: 5rem;
    }
    .home_width{
      min-width: 110rem;
    }
    .quick{
      margin: 0.4rem auto;
      padding: 0.4rem 0 1.8rem;
    }
    /*.home_top{*/
    /*  padding: 0 18rem;*/
    /*}*/

    .calm{
      margin: 1rem auto 0.8rem;
    }

    .tools{
      margin: 0.4rem auto;
    }
    .navimg img{
      /* width: auto; */
    }
  }

  @media screen and (min-width: 1600px){
    /* .navimg img{
      width: auto !important;
    } */
    .home{
      min-width: 1580px;
      padding-bottom: 50px;
    }

    .home_width{
      min-width: 1500px;
    }

    .quick{
      padding: 5px 0 20px;
      margin: 5px auto;
    }

    .home_top{
      padding: 0 200px;
    }

    .calm{
      margin: 5px auto 10px;

    }

    .tools{
      margin: 5px auto;
    }

  }
</style>
<style>
  div .el-carousel__button{
    width: 10px !important;
  }
  div .el-carousel__indicator--horizontal{
    padding: 8px 4px;
  }
  .el-carousel__item{
    text-align: center !important;
  }
</style>
